import * as React from "react";

export interface JoinBlockProps {
    delimiter?: React.ReactElement;
    itemFillStates: boolean[];
    children: React.ReactNode;
}

export function JoinBlock(props: JoinBlockProps): JSX.Element {
    return (
        <>
            {React.Children.toArray(props.children)
                .map((child, sourceIndex) => [child, sourceIndex] as const)
                .filter((_, sourceIndex) => props.itemFillStates[sourceIndex])
                .map(([child, sourceIndex], filteredIndex) => (
                    <React.Fragment key={sourceIndex?.toString() ?? ""}>
                        {filteredIndex > 0 && props.delimiter}
                        {child}
                    </React.Fragment>
                ))}
        </>
    );
}

interface JoinItemProps {
    children: React.ReactNode;
}

export function JoinItem(props: JoinItemProps): JSX.Element {
    return <>{props.children}</>;
}
